import { render, staticRenderFns } from "./TransferMoney.vue?vue&type=template&id=8cc8c6f8&scoped=true&"
import script from "./TransferMoney.vue?vue&type=script&lang=js&"
export * from "./TransferMoney.vue?vue&type=script&lang=js&"
import style0 from "./TransferMoney.vue?vue&type=style&index=0&id=8cc8c6f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc8c6f8",
  null
  
)

export default component.exports